import refreshAttribute from '../utils/refreshAttribute'
import axios from 'axios'
import emitter from '../utils/emitter'
import onResize from '../utils/onResize'

import { get } from '@bigyouth/base'
import { get as getPipe } from '../utils/sigpipe'

import { ACTIONS as MODAL_ACTIONS } from './modal'
import { FORM_ACTIONS } from './formValidation'

import { bpOk as triggerBpOk } from './fbTrigger'

import addParamUrl from './addParamUrl'
import { listParamUrl } from './manageParamUrlModule'
import { modulesWithParams } from './manageParamUrlModule'

export default {
  name: 'comparator',

  selectedProduct: null,
  selectedVersion: null,
  currentStep: 1,

  ui: {
    step1: '[js-comparator-step1]',
    close: '[js-comparator-close]',
    'selectProduct[]': '[js-comparator-select-product]',
    'showVersions[]': '[js-comparator-show-versions]',
    'changeStep[]': '[js-comparator-change-step]',
    form: '[js-comparator-form]',
    switch: '[js-comparator-switch]',
    'switchValues[]': '[js-comparator-switch-value]',
    errorWrap: '[js-comparator-error-wrap]',
  },

  events: [
    {
      target: 'selectProduct',
      on: 'change',
      handle(e) {
        this.changeProduct()
      },
    },
    {
      target: 'switch',
      on: 'change',
      handle(e) {
        this.ui.switchValues.forEach(value => {
          value.classList.toggle('hidden')
        })
      },
    },
    {
      target: 'close',
      on: 'click',
      handle(e) {
        // reset module to first step
        setTimeout(() => {
          this.currentStep = 1
          this.updateActiveTab()
        }, 400)
      },
    },
    {
      target: 'showVersions',
      on: 'click',
      handle: 'showVersionsClicked'
    },
    {
      target: 'changeStep',
      on: 'click',
      handle: 'changeStepClicked'
    },
  ],

  showVersionsClicked(e) {
    this.selectedProduct = e.target.dataset.product
    this.showVersionsStep()
  },

  changeStepClicked(e) {
    const currentStepEl = e.target.closest('[data-step]')
    this.currentStep = currentStepEl.dataset.step
    let type = e.target.dataset.type
    if (type === 'minus') {
      this.currentStep--
      this.changeStep(type)
    } else {
      this.pipe.write({ action: 'validateStep', step: currentStepEl })
    }
  },

  componentDidMount() {
    const formId = this.el.getAttribute('data-form-id')
    this.pipe = getPipe(formId)
    this.pipe.on((message) => {
      const action = message.action
      switch (action) {
        case 'nextStepOk':
          this.currentStep++
          this.changeStep('plus')

          break

        case FORM_ACTIONS.SUBMIT:
          this.currentStep++
          this.submitBP(message.formData)
      }
    })

    this.off = onResize(this.onResize.bind(this))

    // generate content for last step
    emitter.on('comparatorEnd', (param) => {
      const currentStepDOM = this.el.querySelector(`[js-comparator-step][data-step="${this.currentStep}"]`)
      // insert newly generated content
      currentStepDOM.innerHTML = param.content

      // BP, send another request
      param.formData.set('action', 'wp_fp_zoho_boarding_pass__send_boarding_pass_ajax')
      param.formData.set('nonce', currentStepDOM.querySelector('[name=send_bp_nonce]').value)

      axios.post(this.props.url, param.formData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(response2 => {
          triggerBpOk(true)
        })
        .catch(e2 => {
          console.error(e2)
        })

      this.refreshJSAttributes(currentStepDOM)

      this.updateActiveTab()
    })

    // for price button on product fiche
    emitter.on('initStep', (options) => {
      if (this.props.callContext == "need-module") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'module-fin-decrouvrir-le-prix-du-bateau' });
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'prix-1-modele' });
      }

      const loader = document.createElement('div')
      loader.classList.add('loader')
      options.emitter.append(loader)
      options.emitter.classList.add('is-loading')

      this.currentStep = options.step
      this.selectedProduct = options.product
      this.showVersionsStep(true, options.emitter)
    })

    const wrapper = this.el.querySelector('.comparator__inner')
    wrapper.addEventListener('scroll', () => {
      if (this.currentStep === 1) {
        const scrollBar = this.el.querySelector('[js-comparator-scrollbar]')

        if (wrapper.scrollTop > this.introHeight) {
          scrollBar.classList.add('is-visible')
        } else {
          scrollBar.classList.remove('is-visible')
        }
      }
    })
  },

  // for selects in step 1
  changeProduct() {
    const formData = new FormData()
    const selects = this.el.querySelectorAll('[js-comparator-select-product]')
    formData.append('product1', selects[0].value)
    formData.append('product2', selects[1].value)
    formData.append('nonce', this.props.nonce_step1)
    formData.append('action', 'comparator_step1')

    this.isFeet = this.el.querySelector('[js-comparator-switch]').checked

    axios.post(this.props.url, formData)
      .then(response => {
        // insert newly generated content
        this.ui.step1.innerHTML = response.data.data

        this.refreshJSAttributes(this.ui.step1)
      })
      .catch(e => {
        console.error(e)
      })
  },

  showVersionsStep(hideBackButton = false, modalControl = null) {
    const stepNumber = 2

    const formData = new FormData()
    formData.append('product', this.selectedProduct)
    formData.append('step', stepNumber)

    let nonce = this.props[`nonce_step${stepNumber}`]
    formData.append('nonce', nonce)

    let submitAction = `comparator_step${stepNumber}`
    formData.append('action', submitAction)

    axios.post(this.props.url, formData)
      .then(response => {
        const stepDOM = this.el.querySelector(`[js-comparator-step][data-step="${stepNumber}"]`)
        stepDOM.innerHTML = response.data.data
        this.refreshJSAttributes(stepDOM)
        if (hideBackButton) {
          stepDOM.querySelector('.form-page__step-back').classList.add('is-hidden')
        }

        this.currentStep = stepNumber
        this.updateActiveTab()

        if (modalControl) {
          this.pipe.write({ action: MODAL_ACTIONS.OPEN, emitterEl: modalControl })
        }
      })
      .catch(e => {
        console.error(e)
      })
  },

  changeStep(type) {
    this.manageTracking()

    const portStatesSelect = get(`[js-comparator-step][data-step="${this.currentStep}"] [js-port-states]`)
    if (portStatesSelect) {
      const portStatesOptions = portStatesSelect.querySelectorAll('option')
      if (portStatesOptions && portStatesOptions.length === 1) {
        if (type === 'plus') {
          this.currentStep++
        } else {
          this.currentStep--
        }

        this.manageTracking()
      }
    }

    if (type === 'plus') {
      if (this.currentStep === 3) {
        let step2El = this.el.querySelector('[js-comparator-step][data-step="2"]')
        let step2ProductCardHtml = step2El.querySelector('.card-product--no-bg').innerHTML

        for (let productCardStep = 3; productCardStep <= 5; productCardStep++) {
          let iStepEl = this.el.querySelector(`[js-comparator-step][data-step="${productCardStep}"]`)
          iStepEl.querySelector('.card-product--no-bg').innerHTML = step2ProductCardHtml
        }

        this.el.querySelectorAll('[js-port-model]').forEach(domEl => {
          const modelCerealog = this.el.querySelector('[data-id-model-cerealog]').value
          if (domEl.value !== modelCerealog) {
            domEl.value = modelCerealog
            domEl.dispatchEvent(new Event('change', { bubbles: true }))
          }
        })
      }
    }

    this.updateActiveTab()

    addParamUrl(modulesWithParams[Math.min(this.currentStep, 2)], listParamUrl.socialAdvertising)
  },

  refreshJSAttributes(node) {
    // refresh attributes for JS to work again

    const attributes = ['js-comparator-select-product', 'js-custom-select', 'js-comparator-change-step', 'js-comparator-switch', 'js-form-validation']
    attributes.forEach(el => {
      if (node.querySelector(`[${el}]`)) {
        node.querySelectorAll(`[${el}]`).forEach(domEl => {
          refreshAttribute(el)(domEl)
        })
      }
    })

    // put back event listeners on new added content
    node.querySelectorAll('[js-comparator-select-product]').forEach(select => {
      select.addEventListener('change', this.changeProduct)
    })

    node.querySelectorAll('[js-comparator-change-step]').forEach(button => {
      button.addEventListener('click', this.changeStepClicked)
    })

    node.querySelectorAll('[js-comparator-show-versions]').forEach(button => {
      button.addEventListener('click', this.showVersionsClicked)
    })

    if (node.querySelector('[js-comparator-switch]')) {
      node.querySelector('[js-comparator-switch]').addEventListener('click', () => {
        node.querySelectorAll('[js-comparator-switch-value]').forEach(value => {
          value.classList.toggle('hidden')
        })
      })

      if (this.isFeet) {
        node.querySelector('[js-comparator-switch]').click()
      }
    }

    node.querySelectorAll('[js-comparator-version]').forEach((button, i) => {
      if (i === 0) {
        this.selectedVersion = button.value
      }

      button.addEventListener('click', this.changeVersion)
    })
  },

  updateActiveTab() {
    this.el.querySelector('[js-comparator-step].is-active').classList.remove('is-active')
    this.el.querySelector(`[js-comparator-step][data-step="${this.currentStep}"]`).classList.add('is-active')
  },

  manageTracking(lastStep = false) {
    let curStep = this.currentStep
    window.dataLayer = window.dataLayer || [];
    // Pour la gestion du tunnel de sélection du modèle avant le tunne de découverte du prix
    if (this.props && this.props.nonce_step6 && this.props.callContext != "product") {
      //TODO : See why props site is not populate
      //const isSailingSite = this.props.site === 'sailing' ? true : false
      const isSailingSite = window.location.href.includes('catamarans') ? true : false
      const offsetPreFunnel = isSailingSite ? 8 : 5
      let curSteInt = Number(curStep)
      if (isSailingSite) {
        if (curSteInt + offsetPreFunnel == 10) {
          window.dataLayer.push({ 'event': 'module-10-amenagement' });
        } else if (curSteInt + offsetPreFunnel == 11) {
          window.dataLayer.push({ 'event': 'module-11-coordonnees' });
        } else if (curSteInt + offsetPreFunnel == 12) {
          window.dataLayer.push({ 'event': 'module-12-port' });
          window.dataLayer.push({ 'event': 'BP envoyé' });
        }
        /* Pas d'étape de prix dans le tunnel secondaire
        else if (curSteInt + offsetPreFunnel == 13) {
          window.dataLayer.push({ 'event': 'module-13-prix' });
          window.dataLayer.push({ 'event': 'BP envoyé' });
        }*/
      } else {
        if (curSteInt + offsetPreFunnel == 7) {
          window.dataLayer.push({ 'event': 'module-7-amenagement' });
        } else if (curSteInt + offsetPreFunnel == 8) {
          window.dataLayer.push({ 'event': 'module-8-coordonnees' });
        } else if (curSteInt + offsetPreFunnel == 9) {
          window.dataLayer.push({ 'event': 'module-9-port' });
          window.dataLayer.push({ 'event': 'BP envoyé' });
        }
      }
    }
    else {
      if (curStep == 3) {
        window.dataLayer.push({ 'event': 'prix-2-coordonnees' });
      } else if (curStep == 4) {
        window.dataLayer.push({ 'event': 'prix-3-port' });
      } else if (curStep == 5) {
        window.dataLayer.push({ 'event': 'prix-4-question' });
        window.dataLayer.push({ 'event': 'BP envoyé' });
      }
    }
  },

  componentWillUnmount() {
    this.off()
  },

  onResize() {
    this.calcHeightIntro()
  },

  calcHeightIntro() {
    let comparatorIntroEl = this.el.querySelector('.comparator__intro')
    if (comparatorIntroEl) {
      this.introHeight = comparatorIntroEl.offsetHeight + this.el.querySelector('.comparator__step1').offsetTop
    } else if (this.introHeight !== undefined && this.introHeight !== 0) {
      this.introHeight = 0
    }
  },

  changeVersion(e) {
    this.selectedVersion = e.target.value
  },

  submitBP(formData) {
    this.manageTracking()

    const formDataNew = new FormData()
    for (const [key, value] of Object.entries(formData)) {
      if (key === 'product' && !value) {
        formDataNew.append('product', this.selectedProduct)
      } else if (key === 'version' && !value) {
        formDataNew.append('version', this.selectedVersion)
      } else {
        formDataNew.append(key, value)
      }
    }

    formDataNew.append('nonce', this.props[`nonce_step${this.currentStep}`])
    formDataNew.append('action', `comparator_step${this.currentStep}`)
    if (!formDataNew.has('model')) {
      formDataNew.append('model', get('[js-port-model]').value)
    }

    if (get('[js-comparator-error]', this.el)) {
      get('[js-comparator-error]', this.el).remove()
    }

    /* eslint-disable-next-line */
    const loader = document.createElement('div')
    loader.classList.add('loader')
    const submitButton = this.el.querySelector(`[js-comparator-step][data-step="${this.currentStep - 1}"] .form-page__submit`)
    submitButton.prepend(loader)
    submitButton.classList.add('is-loading')

    axios.post(this.props.url, formDataNew, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => {
        if (response.status === 200) {
          get('.loader', this.el).remove()
          submitButton.classList.remove('is-loading')

          emitter.trigger('comparatorEnd', {
            formData: response.config.data,
            content: response.data.data,
          })
        } else {
          console.error(response)
        }
      })
      .catch(e => {
        if (e.response) {
          get('.loader', this.el).remove()
          submitButton.classList.remove('is-loading')

          const error = document.createElement('div')
          error.classList.add('form__error', 'mb-6', 'text-right', 'form-page__padded-content')
          error.setAttribute('js-comparator-error', '')
          error.innerHTML = e.response.data.message !== undefined ? e.response.data.message : translate('FORM_ERROR_SENDING')

          this.ui.errorWrap.prepend(error)
        }
      })
  }
}
